import { Leaf } from "lucide-react";

export const Differentiation = () => {
  return (
    <section className="py-24 bg-card relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-10 right-10 opacity-10">
        <Leaf className="w-40 h-40 text-accent rotate-12" />
      </div>
      <div className="absolute bottom-10 left-10 opacity-10">
        <Leaf className="w-32 h-32 text-accent -rotate-45" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-8">
            A Compassionate Platform for One of Life's Hardest Responsibilities
          </h2>
          
          <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
            <p>
              When we lose someone, honoring their story can feel overwhelming. Living Tribute helps you create something meaningful without stress, confusion, or creative pressure.
            </p>
            <p>
              Where others provide templates, we provide guidance, collaboration, and a deeply personal memorial experience. No technical skills needed. No searching for the right words alone.
            </p>
            <p className="text-foreground font-medium">
              Just a supportive space designed to help you celebrate a loved one with clarity, beauty, and heart.
            </p>
          </div>
          
          {/* Decorative divider */}
          <div className="flex items-center justify-center gap-4 mt-12">
            <div className="h-px w-16 bg-accent/30" />
            <Leaf className="w-5 h-5 text-accent" />
            <div className="h-px w-16 bg-accent/30" />
          </div>
        </div>
      </div>
    </section>
  );
};
